import React from 'react';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import DownloadIcon from '@mui/icons-material/Download';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import { DataTypeProvider } from '@devexpress/dx-react-grid';
import AppDocuServiceCall from '../_Utils/AppDocuServiceCall';
import { notifySomething } from '../_Utils/AppDocuCommon';
import EditGenDocumentDialog from '../GenDocument_Components/EditGenDocumentDialog';

class ActionsFormatter extends React.Component {
  downloadService = async (item) => {
    AppDocuServiceCall.downloadProtectedFile(
      'gen_document/download',
      item.file_hash,
      item.file_name || item.original_filename || 'document',
      notifySomething
    );
  }

  deleteService = async (itemId) => {
    if (!window.confirm('Delete this gen document?')) return;
    try {
      const res = await AppDocuServiceCall.deleteGenDocument(itemId);
      if (res.data && res.data.is_valid === false) {
        notifySomething(res.data.message || 'Error deleting gen document', 'error');
        return;
      }
      await this.props.onItemsChange();
    } catch (error) {
      console.error('Error deleting gen document:', error);
      notifySomething('Error deleting gen document', 'error');
    }
  };

  render() {
    const { row, onOpenEditDialog } = this.props;
    return (
      <div style={{ display: 'flex', gap: 0, alignItems: 'center', minWidth: 80 }}>
        <Tooltip title="Edit">
          <IconButton size="small" onClick={() => onOpenEditDialog && onOpenEditDialog(row)} style={{ padding: 4 }}>
            <EditIcon style={{ color: '#111', fontSize: 20 }} />
          </IconButton>
        </Tooltip>
        <Tooltip title="Delete">
          <IconButton size="small" onClick={() => this.deleteService(row.id)} style={{ padding: 4 }}>
            <DeleteIcon style={{ color: 'darkred', fontSize: 20 }} />
          </IconButton>
        </Tooltip>
        <Tooltip title="Download">
          <IconButton size="small" onClick={() => this.downloadService(row)} style={{ padding: 4 }}>
            <DownloadIcon style={{ color: '#111', fontSize: 20 }} />
          </IconButton>
        </Tooltip>
      </div>
    );
  }
}

export default class GenDocActionsTypeProvider extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      itemDataToEdit: null,
    };
  }

  render() {
    const { for: forColumns, ...rest } = this.props;
    return (
      <>
        <DataTypeProvider
          formatterComponent={props => <ActionsFormatter
            row={props.row}
            onOpenEditDialog={row => this.setState({ itemDataToEdit: row })}
            onItemsChange={this.props.onItemsChange}
          />}
          for={forColumns}
          {...rest} />

        <EditGenDocumentDialog
          itemId={this.state.itemDataToEdit ? this.state.itemDataToEdit.id : null}
          onClose={() => this.setState({ itemDataToEdit: null })}
          onItemsChange={this.props.onItemsChange} />
      </>
    );
  }
}
